import { createAction } from 'redux-starter-kit';
import { requestFailed, requestStart, requestSucceded } from '../../domain/requests/RequestActions';
import {
  putDashboardData,
  updateIssueData,
  updateRateData,
  updateReasonData
} from '../../domain/dashboard/dashboardDataActions';
import { get } from '../../../utility/via-fetch';
import {getDateRangeForDashboardWidgetOption} from "../../../sections/secured/bynx/packageUtil";


/**
 * Get all the data for the dashboard
 */
export const fetchDashboardPageData = createAction('FETCH_DASHBOARD_PAGE_DATA');

/**
 * An action for loading all the data for the dashboard page.
 */
export function requestDashboardPageData(fromQueryDateInitial, toQueryDateInitial, rateOption, reasonOption, issueOption) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchDashboardPageData.toString()));
    dispatch(fetchDashboardPageData(requestId));

    try {
      // Get user locale
      const user = await get('/api/security/current-user');
      const { locale } = user;

      // Main dashboard data (initial - dates will not change)
      const data = await get('/api/dashboard/initial/from/' + fromQueryDateInitial + '/to/' + toQueryDateInitial);

      // Query dates for rate, reasons & issues
      const rateDateRange = rateOption ? getDateRangeForDashboardWidgetOption(rateOption) : [fromQueryDateInitial, toQueryDateInitial];
      const reasonDateRange = reasonOption ? getDateRangeForDashboardWidgetOption(reasonOption) : [fromQueryDateInitial, toQueryDateInitial];
      const issueDateRange = issueOption ? getDateRangeForDashboardWidgetOption(issueOption) : [fromQueryDateInitial, toQueryDateInitial];

      // Rate, reasons & issues
      data.inspectionsByDate = await get('/api/dashboard/inspection-rate/from/' + rateDateRange[0] + '/to/' + rateDateRange[1]);
      data.reasonsByDate = await get('/api/dashboard/inspection-reasons/from/' + reasonDateRange[0] + '/to/' + reasonDateRange[1]);
      data.defectsByDate = await get('/api/dashboard/inspection-issues/from/' + issueDateRange[0] + '/to/' + issueDateRange[1]);

      // Notifications
      data.displayNotifications = await get(`/api/notifications/display/${locale}`);

      // Normalise data. Store the data in the domain, and the ids in the request response.
      dispatch(putDashboardData(data));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * Get inspection rate data for the dashboard
 */
export const fetchDashboardRateData = createAction('FETCH_DASHBOARD_RATE_DATA');

/**
 * Get inspection reason data for the dashboard
 */
export const fetchDashboardReasonData = createAction('FETCH_DASHBOARD_REASON_DATA');

/**
 * Get inspection issue data for the dashboard
 */
export const fetchDashboardIssueData = createAction('FETCH_DASHBOARD_ISSUE_DATA');


/**
 * An action for getting the inspection rate data (after the initial load)
 */
export function requestDashboardRateData(fromQueryDateRate, toQueryDateRate) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchDashboardRateData().toString()));
    dispatch(fetchDashboardRateData(requestId));

    try {
      // Inspection Rate Data
      const inspectionsByDate = await get('/api/dashboard/inspection-rate/from/' + fromQueryDateRate + '/to/' + toQueryDateRate);

      // Update in the stored dashboard data
      dispatch(updateRateData(inspectionsByDate));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * An action for getting the inspection reason data (after the initial load)
 */
export function requestDashboardReasonData(fromQueryDateReason, toQueryDateReason) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchDashboardReasonData().toString()));
    dispatch(fetchDashboardReasonData(requestId));

    try {
      // Inspection Reason Data
      const inspectionReasonsByDate = await get('/api/dashboard/inspection-reasons/from/' + fromQueryDateReason + '/to/' + toQueryDateReason);

      // Update in the stored dashboard data
      dispatch(updateReasonData(inspectionReasonsByDate));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * An action for getting the inspection issue data (after the initial load)
 */
export function requestDashboardIssueData(fromQueryDateIssue, toQueryDateIssue) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchDashboardIssueData.toString()));
    dispatch(fetchDashboardIssueData(requestId));

    try {
      // Inspection Rate Data
      const defectsByDate = await get('/api/dashboard/inspection-issues/from/' + fromQueryDateIssue + '/to/' + toQueryDateIssue);

      // Update in the stored dashboard data
      dispatch(updateIssueData(defectsByDate));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}


/**
 * Set the current widgets
 */
export const setWidgets = createAction('SET_WIDGETS');

/**
 * An action for setting the current widgets
 */
export function updateCurrentWidgets(widgetNoLeft, widgetNoRight, optionRates, optionReasons, optionIssues) {
  return async (dispatch) => {
    dispatch(setWidgets([widgetNoLeft, widgetNoRight, optionRates, optionReasons, optionIssues]));
  };
}
